import { FilterOption } from "@coeff/api-admin-ext";
import React from "react";

import { FlexRow } from "../../../components";
import { CheckboxListPopover } from "../../../components/CheckboxListPopover";
import { pluralizeString } from "../../../utils";
import { ExportCSVButton } from "../../WorkspaceAdmin/ExportCSVButton";
import { TabName } from "../../WorkspaceAdmin/WorkspaceAdmin";
import { TableFilters } from "../useTableFilters";

import { DebouncedSearchInput } from "./DebouncedSearchInput";
import { TriggerFilterPopover, UserFilterPopover } from "./FilterPopovers";

type Props = {
  domain: string;
  search: string;
  onSearchChange: (search: string) => void;
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
};

export const AlertsFilterToolbar: React.FC<Props> = ({
  domain,
  onSearchChange,
  search,
  filters,
  setFilters,
}) => {
  const statusFilterOptions: FilterOption[] = [
    {
      label: "No Error",
      value: "ok",
    },
    {
      label: "Error",
      value: "failed",
    },
  ];

  const destinationFilterOptions: FilterOption[] = [
    {
      label: "Email",
      value: "email",
    },
    {
      label: "Slack",
      value: "slack",
    },
  ];

  const triggerFilterOptions: FilterOption[] = [
    { value: "monitor_change", label: "Monitored change" },
    { value: "monitor_condition", label: "Monitored condition" },
    { value: "new_rows_appended", label: "New rows appended" },
    { value: "new_rows_with_id", label: "New rows with ID" },
    { value: "snapshot", label: "Scheduled" },
  ];

  return (
    <FlexRow style={{ justifyContent: "space-between" }}>
      <DebouncedSearchInput initialSearch={search} onChange={onSearchChange} />

      <FlexRow>
        <CheckboxListPopover
          getLabel={() =>
            filters.status === undefined ||
            filters.status.length === 0 ||
            filters.status.length === statusFilterOptions.length
              ? "All Statuses"
              : filters.status?.some(value => value === "error")
              ? "Has Status Error"
              : "No Status Error"
          }
          initialValues={filters.status}
          options={statusFilterOptions}
          onChange={values =>
            setFilters({
              ...filters,
              status: values,
            })
          }
          buttonProps={{
            className: "gray",
          }}
        />

        <CheckboxListPopover
          getLabel={() =>
            filters.destination === undefined ||
            filters.destination.length === 0 ||
            filters.destination.length === destinationFilterOptions.length
              ? "All Destinations"
              : pluralizeString("Destination", filters.destination.length)
          }
          initialValues={filters.destination}
          options={destinationFilterOptions}
          onChange={values =>
            setFilters({
              ...filters,
              destination: values,
            })
          }
          buttonProps={{
            className: "gray",
          }}
        />

        <CheckboxListPopover
          getLabel={() =>
            filters.alert_type === undefined ||
            filters.alert_type.length === 0 ||
            filters.alert_type.length === triggerFilterOptions.length
              ? "All Triggers"
              : pluralizeString("Trigger", filters.alert_type.length)
          }
          initialValues={filters.alert_type}
          options={triggerFilterOptions}
          onChange={values =>
            setFilters({
              ...filters,
              alert_type: values,
            })
          }
          buttonProps={{
            className: "gray",
          }}
        />

        <UserFilterPopover
          table="alerts"
          domain={domain}
          values={filters.created_by}
          onChange={values =>
            setFilters({
              ...filters,
              created_by: values,
            })
          }
        />

        <ExportCSVButton tab={TabName.alerts} />
      </FlexRow>
    </FlexRow>
  );
};
